import { gridShortDate } from 'utilities';

export default (date: string | null) => (date ? gridShortDate(date) : '');
